import styled from "styled-components";
import { Field } from "redux-form/immutable";
import { useIntl } from "react-intl";

import { creatable } from "../../up-styled-creatable";
import { selectBox } from "../../select-box";
import { renderField } from "../../up-input";
import FormValueSelector from "../../up-form-value-selector";
import UpRegex from "../../up-regex";

import {
  getOptions,
  type ConditionOperator,
  type ConditionProduct,
  type ResettableConditionFilterProps
} from "../utils";

const Filter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media only screen and (max-width: 470px) {
    flex-direction: column;
    align-items: stretch;
    width: auto;
  }
`;

interface RowProps {
  margin?: string;
}

const Row = styled.div<RowProps>`
  display: flex;
  width: 100%;
  margin: ${(props) => (props.margin ? props.margin : "0 0 0 0")};
  @media only screen and (max-width: 680px) {
    margin-top: 0px;
  }
  @media only screen and (max-width: 440px) {
    flex-direction: column;
  }
`;

interface QueryParameterProps extends ResettableConditionFilterProps {
  product: ConditionProduct;
}

const QueryParameter = ({
  member,
  product,
  resetOnChange
}: QueryParameterProps) => {
  const defaultOptions = [
    "equals",
    "empty",
    "not-empty",
    "contains",
    "contains-not"
  ] satisfies readonly ConditionOperator[];
  const intl = useIntl();

  const optionsByProduct: Partial<
    Record<ConditionProduct, readonly ConditionOperator[]>
  > = {
    optin: ["regex"]
  };

  return (
    <Filter>
      <Row>
        <Field
          name={`${member}.filter.parameter`}
          component={renderField}
          placeholder="Parameter"
        />

        <Field
          name={`${member}.filter.operator`}
          component={selectBox}
          customProps={{
            options: getOptions(optionsByProduct[product], defaultOptions).map(
              ({ value, label }) => ({
                value,
                label: intl.formatMessage(label),
              }),
            ),
            minWidth: '140px',
            margin: '0 10px 0 0',
            onChange: () => resetOnChange()
          }}
        />
      </Row>
      <FormValueSelector
        fieldName={`conditions[${member
          .split("[")[1]
          .charAt(0)}]filter.operator`}
      >
        {(operator) => {
          if (operator === "contains" || operator === "contains-not") {
            return (
              <Row margin="10px 0 0 0">
                <Field
                  name={`${member}.filter.attribute`}
                  component={creatable}
                />
              </Row>
            );
          }

          if (operator === "regex") {
            return (
              <Row>
                <UpRegex
                  name={`${member}.filter.attribute[0].value`}
                  margin="10px 10px 0 0"
                  width="100%"
                  fieldValidation={false}
                />
              </Row>
            );
          }

          return undefined;
        }}
      </FormValueSelector>
    </Filter>
  );
};

export default QueryParameter;
